/**
 * Asynchronously loads the component for HomePage
 */

import React from 'react';
import loadable from '../../utils/loadable';
import LoadingIndicator from '../../components/LoadingIndicator';
import { ENTITY_DIALOG_COMPONENT_NAMES } from './constants';

export default loadable(() => import('./index'), {
  fallback: <LoadingIndicator />,
});

export const ENTITY_DIALOG_COMPONENT_MAP = {
  [ENTITY_DIALOG_COMPONENT_NAMES.ADD_DEVICE]: loadable(
    () => import('../../views/Devices/components/AddDeviceFlow/AddDeviceFlowWrapper'),
    { fallback: <LoadingIndicator /> },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.CHANGE_OWNER]: loadable(() => import('../../views/Devices/components/ChangeOwner'), {
    fallback: <LoadingIndicator />,
  }),
  [ENTITY_DIALOG_COMPONENT_NAMES.ADD_USER]: loadable(
    () => import('../../views/Users/components/AddUserFlow/AddUserFlowWrapper'),
    { fallback: <LoadingIndicator /> },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.ADD_BLT_ENTITY]: loadable(
    () => import('../../views/BLTGateway/components/AddGatewayFlow/AddBLTEntityFlowWrapper'),
    { fallback: <LoadingIndicator /> },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.CONFIGURE_BLT_ENTITY]: loadable(
    () => import('../../views/BLTGateway/components/ConfigureGateway/ConfigureGateway'),
    { fallback: <LoadingIndicator /> },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.ADD_RELATIVE]: loadable(() => import('../../views/Devices/components/AddRelation'), {
    fallback: <LoadingIndicator />,
  }),
  [ENTITY_DIALOG_COMPONENT_NAMES.CHANGE_SUPERVISOR]: loadable(
    () => import('../../views/Users/components/AddSupervisor'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.SHOW_DEVICE_MONITORING]: loadable(
    () => import('../../views/Devices/components/ShowMonitoringInfo'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.SHOW_LOCATION_POPOVER]: loadable(
    () => import('../../views/Devices/components/ShowLocationInfo'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.SHOW_OVERVIEW_POPOVER]: loadable(
    () => import('../../views/Users/components/ShowOverviewPopover'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.SHOW_CONFIG_POPOVER]: loadable(
    () => import('../../views/Devices/components/ShowConfiguration'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.ADD_COMPANY_POPOVER]: loadable(
    () => import('../Companies/components/AddUpdateForm/AddUpdateForm'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.ADD_BRANCH_POPOVER]: loadable(
    () => import('../Branches/components/AddUpdateForm/AddUpdateForm'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.ADD_DEVICE_POPOVER]: loadable(
    () => import('../Users/components/AddDeviceToUser/AddDeviceToUser'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.SALES_DASHBOARD_POPOVER]: loadable(
    () => import('../Companies/components/SalesDashboardPopup'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.ADD_BLT_ROOM]: loadable(() => import('../BLTGateway/components/AddRoom/AddRoom'), {
    fallback: <LoadingIndicator />,
  }),
  [ENTITY_DIALOG_COMPONENT_NAMES.MARK_ALERTS_DONE_FORM]: loadable(
    () => import('../BLTGateway/components/MarkAlertsDoneForm/MarkAlertsDoneForm'),
    {
      fallback: <LoadingIndicator />,
    },
  ),
  [ENTITY_DIALOG_COMPONENT_NAMES.CLONE_DEVICES]: loadable(
    () => import('../Devices/components/CloneDevice/CloneDevice'),
    {
      fallback: <LoadingIndicator/>,
    }
  )
};
